module.exports = __webpack_public_path__ + "components/media-kit/static/icon-latin-america-388da12525d3810b660972874521a75b.svg";